import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const FoundingStory = () => {
  return (
    <section className="pt-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Our Founding Story
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Born out of ambition, Kharbanda Motors is a legacy business with an
            aim to revolutionize the accessibility of genuine car spare parts in
            India.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Story Content */}
          <div className="space-y-8">
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-accent">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                  <Icon
                    name="Settings"
                    size={24}
                    color="var(--color-accent)"
                    strokeWidth={2}
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-text-primary mb-2">
                    KHARBANDA MOTORS
                  </h3>
                  <p className="text-text-secondary">
                    Established in 1984 by two ambitious brothers, Kharbanda
                    Motors has proudly served the heart of Prayagraj for 40
                    years. We are dedicated to providing top-quality automotive
                    services and genuine parts for Maruti, Hyundai, Mahindra,
                    Tata, Toyota, Renault and more.
                    <br />
                    <br />
                    Our services include electrical work, a state-of-the-art
                    body shop for denting and painting, and expert mechanical
                    jobs. We also offer tire solutions from trusted brands like
                    JKTyres, Apollo, and MRF, along with alignment and wheel
                    balancing.
                    <br />
                    <br />
                    With a team of skilled technicians and mechanics, we
                    constantly evolve with the latest technologies in the
                    automotive industry. Our mission is to continue our legacy
                    of trust and reliability, serving Prayagraj’s automotive
                    needs for generations to come.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Founders Image */}
          <div className="relative">
            <div className="overflow-hidden ">
              <Image
                src="3d.png"
                alt="Kharbanda Motors founders Rajesh Kumar and Priya Sharma in their first office"
                className="w-full h-80 object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-lg shadow-automotive-lg border border-border">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent">1986</div>
                <div className="text-sm text-text-secondary">Founded</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundingStory;
